import React, { useState } from 'react'

import { ModalHeader, StyledModal, StyledTabs } from './styles'
import { useTranslation } from 'i18n'
import EnglishModal from 'components/english-level/english-modal'

interface ClassificationModalProps {
  show: boolean
  onClose(): void
}

const ClassificationModal: React.FC<ClassificationModalProps> = ({
  show = true,
  onClose
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(1)
  const { t } = useTranslation()

  const items = [
    {
      id: 1,
      label: 'CEFR'
    },
    {
      id: 2,
      label: 'A-Z'
    },
    {
      id: 3,
      label: t('Tabela Comparativa')
    }
  ]

  const handleChangeTab = selected => {
    setSelectedTab(selected.id)
  }

  return (
    <StyledModal show={show} onClose={onClose}>
      <ModalHeader>
        <h2>{t('Conheça as classificações')}</h2>
      </ModalHeader>
      <StyledTabs items={items} onChangeTab={handleChangeTab} />
      {selectedTab === 1 && <EnglishModal isCEFR onClose={onClose} />}
      {selectedTab === 2 && <EnglishModal onClose={onClose} />}
      {selectedTab === 3 && (
        <EnglishModal onClose={onClose} isComparativeTable />
      )}
    </StyledModal>
  )
}

export default ClassificationModal
